export function getCookieByName(name) {
  const result = document.cookie.split(";").find((p) => p.includes(name));
  let value = result?.slice(result.indexOf("=") + 1) ?? undefined;
  if (value === "undefined" || !value) {
    return undefined;
  }
  return parseInt(value);
}

export function setCookie(value) {
  let name = "ticketType";
  document.cookie = name + " = " + value;
}
